export const Actions = {
  READ_COMPANY: "READ_COMPANY",
  READ_COMPANY_SUCCEEDED: "READ_COMPANY_SUCCEEDED",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  UPDATE_COMPANY_SUCCEEDED: "UPDATE_COMPANY_SUCCEEDED",
  UPLOAD_CONTRACT: "UPLOAD_CONTRACT",
  UPLOAD_CONTRACT_SUCCEEDED: "UPLOAD_CONTRACT_SUCCEEDED",
  CLEAR_OPERATION_RESULT: "COMPANY_CLEAR_OPERATION_RESULT",
};